import React from 'react';
import classNames from 'classnames';
import {
  Key,
  Scope,
  registerShortcut,
  unregisterShortcut,
} from '@trello/keybindings';
import {
  LayerManagerPortal,
  Layers,
} from 'app/gamma/src/components/layer-manager';

import styles from './Overlay.less';

export enum OverlayBackground {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum OverlayAlignment {
  TOP = 'top',
}

interface OverlayProps {
  background: OverlayBackground;
  alignment?: OverlayAlignment;
  className?: string;
  closeOnEscape?: boolean;
  onClose: () => void;
}

const noop = () => {};

export class Overlay extends React.Component<OverlayProps> {
  componentDidMount() {
    registerShortcut(this.handleEscape, {
      scope: Scope.Overlay,
      key: Key.Escape,
    });
  }

  componentWillUnmount() {
    unregisterShortcut(this.handleEscape);
  }

  handleEscape = (e: React.KeyboardEvent<HTMLElement>) => {
    const { closeOnEscape = true, onClose = noop } = this.props;
    if (closeOnEscape) {
      onClose();
    }
  };

  render() {
    const {
      background = OverlayBackground.LIGHT,
      className = '',
      children,
      onClose = noop,
      alignment,
    } = this.props;

    return (
      <LayerManagerPortal layer={Layers.Overlay}>
        <div
          className={classNames(
            { [styles.alignTop]: alignment === OverlayAlignment.TOP },
            styles.overlay,
            styles[background],
            className,
          )}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => {
            // Ignore events bubbled from children, or if a popover is open (the
            // popover component listens at the document level, and will close
            // itself)
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
          role="button"
        >
          <div className={styles.contents}>{children}</div>
        </div>
      </LayerManagerPortal>
    );
  }
}
